// ABOUTME: Starts a route's data and page chunk while the session check is still in flight
// ABOUTME: Runs only with a stored token; AuthGate still decides whether the page renders

import type { QueryClient } from '@tanstack/react-query';
import { auth, SKIP_AUTH } from './auth-client';
import {
  portfolioEnrichedQueryOptions,
  portfoliosQueryOptions,
  summaryQueryOptions,
} from './queries/portfolios';

export interface RouteImporters {
  list: () => Promise<unknown>;
  detail: () => Promise<unknown>;
}

const defaultImporters: RouteImporters = {
  list: () => import('../pages/PortfoliosListPage'),
  detail: () => import('../pages/PortfolioPage'),
};

const LIST_PATH = /^\/portfolios?\/?$/;
const DETAIL_PATH = /^\/portfolios?\/([^/]+)\/?$/;

export async function startRoutePrefetch(
  queryClient: QueryClient,
  pathname: string,
  importers: RouteImporters = defaultImporters
): Promise<void> {
  if (!SKIP_AUTH && !auth.getToken()) return;

  const work: Promise<unknown>[] = [queryClient.prefetchQuery(portfoliosQueryOptions)];
  const detail = DETAIL_PATH.exec(pathname);
  if (LIST_PATH.test(pathname)) {
    work.push(queryClient.prefetchQuery(summaryQueryOptions));
    work.push(importers.list().catch(() => undefined));
  } else if (detail) {
    work.push(queryClient.prefetchQuery(portfolioEnrichedQueryOptions(detail[1]!)));
    work.push(importers.detail().catch(() => undefined));
  }
  await Promise.all(work);
}
